import { apiClient } from '@/services/Axios';
import { unwrapV1, v1Delete, v1Get, v1Patch, v1Post } from '@/services/v1Api';

function subHiresBase(projectId, equipmentListId) {
    return `/api/v1/projects/${projectId}/equipment-lists/${equipmentListId}/sub-hires`;
}

export async function getEquipmentListSubHire(projectId, equipmentListId, subHireId) {
    const { data } = await v1Get(`${subHiresBase(projectId, equipmentListId)}/${subHireId}`);
    return data;
}

export async function getEquipmentListSubHires(projectId, equipmentListId, params = {}) {
    const { data } = await v1Get(subHiresBase(projectId, equipmentListId), params);
    return Array.isArray(data) ? data : [];
}

export async function createEquipmentListSubHire(projectId, equipmentListId, payload) {
    const { data } = await v1Post(subHiresBase(projectId, equipmentListId), payload);
    return data;
}

export async function updateEquipmentListSubHire(projectId, equipmentListId, subHireId, payload) {
    const { data } = await v1Patch(`${subHiresBase(projectId, equipmentListId)}/${subHireId}`, payload);
    return data;
}

export async function deleteEquipmentListSubHire(projectId, equipmentListId, subHireId) {
    await v1Delete(`${subHiresBase(projectId, equipmentListId)}/${subHireId}`);
}

export async function addSubHireLine(projectId, equipmentListId, subHireId, payload) {
    const { data } = await v1Post(`${subHiresBase(projectId, equipmentListId)}/${subHireId}/lines`, payload);
    return data;
}

export async function updateSubHireLine(projectId, equipmentListId, subHireId, lineId, payload) {
    const { data } = await v1Patch(
        `${subHiresBase(projectId, equipmentListId)}/${subHireId}/lines/${lineId}`,
        payload,
    );
    return data;
}

export async function deleteSubHireLine(projectId, equipmentListId, subHireId, lineId) {
    await v1Delete(`${subHiresBase(projectId, equipmentListId)}/${subHireId}/lines/${lineId}`);
}

export async function createSubHirePurchaseOrder(projectId, equipmentListId, subHireId) {
    const { data } = await v1Post(
        `${subHiresBase(projectId, equipmentListId)}/${subHireId}/purchase-orders`,
    );
    return data;
}

export async function getSubHireSuppliers(projectId, equipmentListId, subHireId) {
    const { data } = await v1Get(`${subHiresBase(projectId, equipmentListId)}/${subHireId}/suppliers`);
    return data;
}

export async function uploadSubHireDocument(projectId, equipmentListId, subHireId, formData) {
    const response = await apiClient.post(
        `/api/v1/projects/${projectId}/equipment-lists/${equipmentListId}/sub-hires/${subHireId}/documents`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    const { data } = unwrapV1(response);
    return data;
}

export async function downloadSubHireDocument(projectId, equipmentListId, subHireId, documentId) {
    return apiClient.get(
        `/api/v1/projects/${projectId}/equipment-lists/${equipmentListId}/sub-hires/${subHireId}/documents/${documentId}/download`,
        { responseType: 'blob' },
    );
}

export async function deleteSubHireDocument(projectId, equipmentListId, subHireId, documentId) {
    await v1Delete(
        `/api/v1/projects/${projectId}/equipment-lists/${equipmentListId}/sub-hires/${subHireId}/documents/${documentId}`,
    );
}
